/**
 * Default Theme Overrides
 * Fallback theme - uses Atlas colors from semanticColors
 */

import type { ClientThemeOverrides } from '../utils/themeAugmentation';
import logo from '../../../themes/default/default.png';

export const defaultThemeOverrides: ClientThemeOverrides = {
  clientId: 'default',
  logo,
  palette: {
    light: {
      // Uses Atlas colors from semanticColors (no override needed)
      // primary.main = #2F7A6D (Primary 500)
      // primary.dark = #1F4D45 (Primary 700 - header)
    },
  },
  typography: {
    h4: {
      color: 'rgba(0, 0, 0, 0.77)',
    },
    h5: {
      color: 'rgba(0, 0, 0, 0.77)',
    },
  },
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          minWidth: '100px',
        },
      },
    },
  },
};
